import List from "@mui/icons-material/List";
import LooksOneOutlined from "@mui/icons-material/LooksOneOutlined";
import Button from "@mui/material/Button";
import classNames from "classnames";
import { Controller } from "react-hook-form";
import { useFormConfigContext } from "./ConfigFormContext";
import { ExtractionQueryPath } from "./ConfigUtils";

const SingleMany = ({
  isReadOnly,
  queryPath,
}: {
  isReadOnly: boolean;
  queryPath: ExtractionQueryPath;
}) => {
  const { control } = useFormConfigContext();
  return (
    <Controller
      name={`${queryPath}.many`}
      control={control}
      render={({ field: { onChange, value, ...props } }) => (
        <div className="flex items-center gap-2 border rounded-lg p-1 h-full">
          <Button
            disabled={isReadOnly}
            {...props}
            onClick={() => onChange(false)}
            className={classNames(
              "flex items-center gap-1 px-3 py-1.5 rounded",
              {
                "bg-blue-100 text-blue-700": !value && !isReadOnly,
                "bg-gray-100 text-gray-700": !value && isReadOnly,
                "text-gray-600 hover:bg-gray-100": value && !isReadOnly,
                "text-gray-600": value && isReadOnly,
              }
            )}
          >
            <LooksOneOutlined className="w-4 h-4" />
            <span>Unique</span>
          </Button>
          <Button
            disabled={isReadOnly}
            {...props}
            onClick={() => onChange(true)}
            className={classNames(
              "flex items-center gap-1 px-3 py-1.5 rounded",
              {
                "bg-blue-100 text-blue-700": value && !isReadOnly,
                "bg-gray-100 text-gray-700": value && isReadOnly,
                "text-gray-600 hover:bg-gray-100": !value && !isReadOnly,
                "text-gray-600": !value && isReadOnly,
              }
            )}
          >
            <List className="w-4 h-4" />
            <span>Multiple</span>
          </Button>
        </div>
      )}
    />
  );
};

export default SingleMany;
